var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"code_wrap"},[_c('p',[_vm._v("(手机上传方式)请微信扫描二维码，上传选择题答案和主观题图片。")]),_c('div',{ref:"qrCodeUrl",staticClass:"qrcode"})])}
var staticRenderFns = []

export { render, staticRenderFns }